// extracted by mini-css-extract-plugin
export var chevron = "_lp-4";
export var chevronExpanded = "_lp-5";
export var row = "_lp-0";
export var rowBody = "_lp-6";
export var rowDescription = "_lp-7";
export var rowHeader = "_lp-1";
export var rowTitle = "_lp-2";
export var rowTitleComplete = "_lp-3";